var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"leads",attrs:{"title":"Leads"}},[_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Ny',
			value: 'new'
		},
		{
			label: 'Afventer',
			value: 'pending'
		},
		{
			label: 'Følg op',
			value: 'followup'
		}
	]},slot:"tools",model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_c('button-view',{attrs:{"slot":"tools","label":"Opret"},on:{"click":function($event){return _vm.open(null)}},slot:"tools"}),_c('new-table-view',{attrs:{"columns":[
		{
			label: 'Status',
			name: ['status'],
			translation: _vm._status,
			template: {
				name: 'status',
				params: {
					color: {
						name: ['status'],
						translation: _vm._statusColors
					},
					description: {
						name: ['status'],
						translation: _vm._statusDesc
					}
				}
			}
		},
		{
			label: 'Modtaget',
			name: 'created',
			filter: 'timestamp',
			weight: 2
		},
		{
			label: 'Nr',
			name: 'num',
			filter: 'integer'
		},
		{
			label: 'Type',
			name: ['details', 'type'],
			translation: {
				private: 	'Privat',
				business: 	'Erhverv'
			}
		},
		/*{
			label: 'Oprettet',
			name: 'created',
			filter: 'timestamp'
		},*/
		{
			label: 'Kvm',
			name: ['details', 'area']
		},
		{
			label: 'Fra',
			name: ['details', 'address', 'city']
		},
		{
			label: 'Til',
			name: ['details', 'dest', 'city']
		},
		{
			label: 'Navn',
			name: 'name'
		},
		{
			label: 'Telefon',
			name: 'phone',
			//filter: 'float',
			//align: 'right'
		},
		{
			label: 'Kunde',
			name: ['_embedded', 'contact', 'name'],
			//filter: 'float',
			//align: 'right'
		},
		{
			label: 'Ansvarlig',
			name: ['_embedded', 'employee', 'name'],
			//filter: 'float',
			//align: 'right'
		},
		{
			label: '',
			name: 'context',
			align: 'right',
			template: {
				name: 'button',
				label: '...'
			}
		}			
	],"items":_vm._items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }